export class Employee {
    employeeId:number
    fullName: string
    storeId: number
    email: string
}
